import Controller from "../abstracts/Controller";

export default class SearchController extends Controller {
  static get COMPONENTS() {
    return [
      'FiltersComponent',
      'SortByComponent',
      'ListingLayoutComponent',
      'PaginationComponent'
    ];
  }
}
